import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { isProduct, ProductId } from "multitenancy/product";

import { usePermissions } from "hooks/permission";

import { useAppSelector } from "store/rootReducer";

import { httpType } from "global/types";

import { ContainerCrud, permitionsCrud } from "features/cruds";
import { IFormOneLabel } from "features/forms/FormOneLabel/interface";
import { IModelFormBase } from "features/forms/optionsForms";
import { AdminAreaSkeleton } from "features/LoadSkeleton";

import api from "services/api";

import { FORMS_ADMIN } from "utils/entities/permission";

export const HearingFileType: React.FC = () => {
  const { t } = useTranslation();
  const [onSubmitForm, setOnSubmitForm] = useState<number>(0);
  const [objectRetorned, setObjectRetorned] = useState<IFormOneLabel | null>(
    null,
  );
  const [httpType, setHttpType] = useState<httpType>("post");
  const [listHearingFileType, setListHearingFileType] = useState<
    Array<IFormOneLabel>
  >([]);

  const [loading, setLoading] = useState<boolean>(true);

  const { user } = useAppSelector((state) => state.user);

  const perms = usePermissions(FORMS_ADMIN.HEARING_FILE_TYPE);
  const previewBypass =
    isProduct(ProductId.Inquerito) &&
    !perms.read &&
    !perms.create &&
    !perms.edit;
  const read = previewBypass ? true : perms.read;
  const create = previewBypass ? true : perms.create;
  const edit = previewBypass ? true : perms.edit;

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    setLoading(true);
    const hearingFileTypes = await api.get(
      `/v1/HearingFileType/GetAllByCustomerId?customerId=${user?.customerId}`,
    );

    setListHearingFileType(hearingFileTypes.data.data ?? []);
    setLoading(false);
  }

  const modelFormBase: IModelFormBase = {
    api: api,
    endPoint: "/v1/HearingFileType/",
    httpType: httpType,
    setHttpType: setHttpType,
    list: listHearingFileType,
    onSubmitForm: onSubmitForm,
    setOnSubmitForm: setOnSubmitForm,
    objectRetorned: objectRetorned,
    setObjectRetorned: setObjectRetorned,
  };

  const formOneLabel: IFormOneLabel = {
    active: true,
    customerId: user?.customerId,
    displayLabel: t("administration.hearingFileTypes.title"),
    id: 0,
    name: "",
    modelFormBase: modelFormBase,
    titleToast: t("administration.hearingFileTypes.title"),
  };

  const permissions: permitionsCrud = {
    inactivate: false,
    toCreate: create,
    toEdit: edit,
    toRead: read,
  };

  return (
    <ContainerCrud
      list={listHearingFileType}
      title={t("administration.hearingFileTypes.title")}
      emptyListMessage={t("administration.hearingFileTypes.notFound")}
      permissions={permissions}
      customProsForm={formOneLabel}
      modelFormBase={modelFormBase}
      optionForm="FormOneLabel"
      loading={loading}
      isAudience={t("administration.hearingFileTypes.title")}
      SkeletonComponent={AdminAreaSkeleton}
    />
  );
};
